<template>
  <div class="page5 full-page">
    <!-- <img class="download-bg" src="@/assets/fullpageImage/download_bg.png" alt=""> -->
    <div class="content">
      <h3 class="page5-shao-ani" :class="zhoren != 'zh' ?'isen':''">{{$t('page5title')}}</h3>
      <div class="english-label">Report Download</div>

      <div class="des">{{$t('index_des')}}</div>

      <p @click="download" class="download hvr-float-shadow page5-shao-ani">
        <span>{{$t('page5download')}}</span>
        <img src="" alt="">

      </p>
      <a href="#" id="downHref" download></a>
      

    </div>
    <img class="computer-bg" src="@/assets/fullpageImage/diannao.png" alt="">

    <!-- <ul class="report-list">
      <li class="page5-shao-ani">
        <i class="el-icon-check" v-show="downloadList.includes('report1-file.pdf')"></i>
        <div class="img-box" @click="checkedItem('report1-file.pdf')">
          <img src="../../../public/report/report1.png" />
        </div>
        <p>{{$t('page5item1')}}</p>
      </li>
      <li class="page5-shao-ani">
        <i class="el-icon-check" v-show="downloadList.includes('report2-file.pdf')"></i>
        <div class="img-box" @click="checkedItem('report2-file.pdf')">
          <img src="../../../public/report/report2.png" />
        </div>
        <p>{{$t('page5item2')}}</p>
      </li>
      <li class="page5-shao-ani">
        <i class="el-icon-check" v-show="downloadList.includes('report3-file.pdf')"></i>
        <div class="img-box" @click="checkedItem('report3-file.pdf')">
          <img src="../../../public/report/report3.png" />
        </div>
        <p>{{$t('page5item3')}}</p>
      </li>
      <li class="page5-shao-ani">
        <i class="el-icon-check" v-show="downloadList.includes('report4-file.pdf')"></i>
        <div class="img-box" @click="checkedItem('report4-file.pdf')">
          <img src="../../../public/report/report4.png" />
        </div>
        <p>{{$t('page5item4')}}</p>
      </li>
      <li class="page5-shao-ani">
        <i class="el-icon-check" v-show="downloadList.includes('report5-file.pdf')"></i>
        <div class="img-box" @click="checkedItem('report5-file.pdf')">
          <img src="../../../public/report/report5.png" />
        </div>
        <p>{{$t('page5item5')}}</p>
      </li>
      <li class="page5-shao-ani">
        <i class="el-icon-check" v-show="downloadList.includes('report6-file.xls')"></i>
        <div class="img-box" @click="checkedItem('report6-file.xls')">
          <img src="../../../public/report/report6.png"  />
        </div>
        <p>{{$t('page5item6')}}</p>
      </li>
    </ul> -->
    <!--/report/reportlist.rar-->
    
  </div>
</template>

<script>
import $ from "jquery";
import { downloadReport } from '@/api/report.js';
export default {
  name: "page5",
  data() {
    return {
      downloadList: [],
       zhoren: localStorage.getItem("locale") || 'zh',
    };
  },
  methods: {
    //选中
    checkedItem(item) {
      if (this.downloadList.includes(item)) {
        let index = this.downloadList.indexOf(item);
        this.downloadList.splice(index, 1);
      } else {
        this.downloadList.push(item);
      }
    },
    //下载
    async download() {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      let that = this;
      let defaultDownList =
        this.downloadList.length === 0
          ? [
              "report1-file.pdf",
              "report2-file.pdf",
              "report3-file.pdf",
              "report4-file.pdf",
              "report5-file.pdf",
              "report6-file.xls"
            ]
          : this.downloadList;
      if (userInfo) {
        let file=Array.from(defaultDownList,(item,index)=>"file["+0+']=http://www.inspector.ltd/'+item);
        for(let i=0;i<file.length;i++){
          setTimeout(function(){
            window.open("http://www.inspector.ltd/api/com/download?"+file[i]) ;
          },400*i)
           
        };
       
         
    /*     for (let i = 0; i < defaultDownList.length; i++) {
          setTimeout(function() {
            document.querySelector("#downHref").href =
              "http://www.inspector.ltd/" + defaultDownList[i];
            document.querySelector("#downHref").click();
          }, 300 * i);
        } */
      } else {
        this.$message.error("请登录后下载报告模版");
      }
    }
  },
  watch: {
    "$route.hash": {
      handler(val) {
        if (this.$route.hash === "#page5") {
          if (
            !$(".page5-shao-ani")
              .eq(0)
              .hasClass("animated")
          ) {
            $(".page5-shao-ani").css({ visibility: "hidden" });
          }
          setTimeout(function() {
            $(".page5-shao-ani")
              .eq(0)
              .css({ visibility: "visible" })
              .addClass("animated fadeInRightBig");
          }, 1000);
          for (let i = 1; i < 8; i++) {
            setTimeout(function() {
              $(".page5-shao-ani")
                .eq(i)
                .css({ visibility: "visible" })
                .addClass("animated fadeInUp");
            }, 1000 + 300 * i);
          }
        }
      },
      immediate: true
    }
  }
};
</script>

<style scoped lang="scss">
$width: 8.21px;
.page5 {
  min-width: 1200px;
  // height: 100%;
  position: relative;
  background-image: url("../../assets/fullpageImage/download_bg.png");
  background-size: 100% 100%;
  // padding: 26px / $width * 1vh 40px / $width * 1vh;
  // box-sizing: border-box;
  // text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  // .download-bg {
  //   width: 100%;

  // }
  .computer-bg {
    width: 500px;
  }
  .content {
    // padding-top: 50px;
    // position: absolute;
    // top: 0;
    // width: 50%;
    // left: 10%;
    padding: 136px 0;

    color: #fff;
    &>div {
      // width: 50%;
      text-align: left;
    }
    .english-label {
      color: #999999;
      margin-top: 10px;
      font-family:"Times New Roman";
    }
    .des {
      margin: 50px 0 60px 0;
    }
  }
  #downHref {
    position: fixed;
    
    
  }
  h3 {
    // height: 152px / $width * 1vh;
    // background-image: url("../../assets/fullpageImage/page5_eng_title.png");
    background-repeat: no-repeat;
    background-size: auto 58px / $width * 1vh;
    color: #fff;
    font-size: 48px;
    font-family: "黑体";
    text-align: left;
    // padding-bottom: 20px / $width * 1vh;
    box-sizing: border-box;
    position: relative;
    &:after {
      content: "";
      display: block;
      background-color: #FF5023;
      height: 4px;
      border-radius: 3px;
      position: absolute;
      bottom: -3px;
    }
    &::after {
      width: 94px;
      left: 0;
    }
    // &::before {
    //   width: 22px / $width * 1vh;
    //   left: 94px / $width * 1vh;
    // }
    &.isen{
      background-image: none;
      height: auto;
      padding-top: 0;
    }
  }
  // .report-list {
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   width: 1326px;
  //   margin: 100px / $width * 1vh auto 60px / $width * 1vh;
  //   li {
  //     flex: 1;
  //     text-align: center;
  //     position: relative;
  //     .el-icon-check {
  //       position: absolute;
  //       right: 14px;
  //       bottom: 4px;
  //       font-size: 32px;
  //       color: #f16a14;
  //       z-index: 2;
  //     }
  //     .img-box {
  //       cursor: pointer;
  //       position: relative;
  //       /*  &.checked:after {
  //         content: "";
  //         display: block;
  //         position: absolute;
  //         left: 0;
  //         top: 0;
  //         right: 0;
  //         bottom: 0;
  //         background-color: rgba(0, 0, 0, 0.5);
  //       } */
  //     }
  //     img {
  //       display: inline-block;
  //       height: 240px;
  //       box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  //     }
  //     p {
  //       color: #2f2f2e;
  //       font-size: 18px / $width * 1vh;
  //       line-height: 50px / $width * 1vh;
  //     }
  //   }
  // }
  .download {
    display: inline-block;
    width: 220px;
    height: 60px;
    border: 1px solid #FF5023;
    color: #ffffff;
    text-decoration: none;
    text-align: center;
    line-height: 60px;
    border-radius: 6px;
    background: #FF5023;
    cursor: pointer;
    // margin: 0 auto;
  }
}
@media screen and (max-width: 720px) {
  .page5 {
    width: 100%;
    min-width: auto;
    // padding: 10px / $width * 1vh 0;
    // display: block;

    // .report-list {
    //   width: 100%;
    //   flex-direction: row-reverse;
    //   justify-content: space-around;
    //   flex-wrap: wrap;
    //   margin: 50px / $width * 1vh auto 60px / $width * 1vh;
    //   li {
    //     flex: auto;
    //     width: 42%;
    //     margin: 0 4%;
    //     img {
    //       width: 100%;
    //       height: auto;
    //     }
    //   }
    // }
    .computer-bg {
      width: 140px;
      display: none;
    }
    .content {
      padding: 36px 0;
      width: 70%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .des,
      .english-label {
        font-size: 10px;
      }
      .english-label  {
        margin-top: 16px;
      }
      .des {
        margin: 10px 0 15px 0;
      }
      
    }
    h3 {
      font-size: 28px;

      &:after {
        height: 6px / $width * 1vh;
        bottom: -14px;
      }
    }
    .download {
      width: 130px;
      height: 36px;
      line-height: 36px;
    }
  }
}
</style>